import get from 'lodash/get';
import { PRINTS_6X4_PROMOTION_KEY } from './constants';

const hasPrints = ({ size, prints }) => {
  const sizes = get(prints, 'sizes', []);
  return sizes.some((s) => s.size === size && !s.deleted);
};

export const getPromotionMessageKey = ({ features, prints }) => {
  if (
    get(features, 'walmart_plus_promotions', false) &&
    hasPrints({ size: '6x4', prints })
  ) {
    return PRINTS_6X4_PROMOTION_KEY;
  }

  return null;
};
